import React, { Component } from 'react';
import firebase from '../../config/Firebase'
import './style.css'
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            firebaseError: null
        }
    }

    componentDidMount() {
        var user = firebase.auth().currentUser;
        if(user) {
            this.props.history.push("/")
        } else {
            this.props.history.push('/login')
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        var { email, password } = this.state;
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(user => {
                // window.location.href="/"
                this.props.history.push("/")
            })
            .catch(err => {
                this.setState({
                    firebaseError: err.message
                })
            })
    }

    render() {
        var { email, password, firebaseError } = this.state;
        return (
            <>
                <div className="login__page pt-5 pb-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h3 className="account__page--title">Đăng nhập</h3>
                            </div>
                            <div className="col-12">
                                <h3 className="account__page--title">{firebaseError}</h3>
                                <div className="customer-login">
                                    <form id="customer_login" action="/account/recover" method="POST">
                                        <div className="large_form">
                                            <label htmlFor="customer_email" className="icon-field">
                                                <i className="fa fa-envelope icon-login" />
                                            </label>
                                            <input
                                                required
                                                type="email"
                                                name="email"
                                                id="customer_email"
                                                placeholder="Email"
                                                className="customer_input"
                                                value={email}
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                        <div className="large_form">
                                            <label htmlFor="customer_password" className="icon-field">
                                                <i className="fas fa-shield-alt icon-login" />
                                            </label>
                                            <input
                                                required
                                                type="password"
                                                name="password"
                                                id="customer_password"
                                                placeholder="Mật khẩu"
                                                className="customer_input"
                                                size={16}
                                                value={password}
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                        <div className="action_bottom">
                                            <input
                                                className="btn btn-signin"
                                                type="submit"
                                                defaultValue="Đăng nhập"
                                                onClick={this.handleSubmit}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Login;
